import { routes } from 'utils/routing';

export const usePendingSubmittedOrderCheckoutRoute = () => routes.cartCheckout;
